import { z } from "zod";

export const specSchema = z.object({
  type: z.string().min(1, "Type is required"),
  unit: z.string().min(1, "Unit is required"),
  topic_id: z.number().optional().nullable(),
});

export const formSchema = z.object({
  specs: z.array(specSchema).min(1, "At least one spec is required"),
});

export type FormType = z.infer<typeof formSchema>;
